import {Fragment} from "react";
import TopNavigation from "../components/TopNavigation/TopNavigation";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CaseEntry from "../components/Law/CaseEntry";
import AuditEntry from "../components/Audit/AuditEntry";
import AuditDashboard from "../components/Audit/AuditDashboard";
import NewAuditEntry from "../components/Audit/NewAuditEntry";
import BinVisitReport from "../components/Report/BinVisitReport";

export default function AuditPage(){



    return(
        <Fragment>
            <TopNavigation/>
            <div className="purchaseDiv text-center mergin_top">
                <BinVisitReport/>
            </div>
        </Fragment>
    )
}
